import BaseModel from '../base/BaseModel.model';
import Evaluacion from './evaluacion.model';
import Pregunta from './pregunta.model';
import { AnswerType } from '@/enums/AsnwerType';

export default class PreguntaOpcionRespuesta extends BaseModel {

    public valorBool:boolean | null;
    public valorString:string | null;
    public respuesta: string | Boolean | null;
    public valorInt:Number | null;
    public orden:Number | null;
    public preguntaId:number;
    public pregunta: Pregunta | null;
    public tipoRespuesta: AnswerType | null;
    
    constructor(){
        super();
        this.init();
    }

    init(){

        this.valorBool = null;
        this.valorString = null;
        this.valorInt = null;
        this.preguntaId = 0;
        this.evaluacion = null;
        this.orden = null;
        this.evaluacionId = null;
        this.tipoRespuesta = null;
    }
}